import "./TableFill.scss";

interface IProps {}

export default function TableHeaderFill(props: IProps) {
    return <div className="userful-table-header-fill-cell" />;
}
